import React from "react";
import { LegacyCarbonRemovalProjectType } from "@ecologi/shared";
import { ProjectVisualsType } from "./project-visuals";
import RemovalIcon from "@ecologi/assets/icons/ProjectInsights/removal.svg";

const PATH = "/images/app/forest/carbon_removal/pictograms/";

export const carbonRemovalVisuals: Record<
  LegacyCarbonRemovalProjectType,
  ProjectVisualsType
> = {
  [LegacyCarbonRemovalProjectType.AfforestationReforestationAndRevegetation]: {
    icon: <RemovalIcon />,
    pictogram: `${PATH}arr.svg`,
  },
  [LegacyCarbonRemovalProjectType.BlueCarbon]: {
    icon: <RemovalIcon />,
    pictogram: `${PATH}blue-carbon.svg`,
  },
  [LegacyCarbonRemovalProjectType.Biochar]: {
    icon: <RemovalIcon />,
    pictogram: `${PATH}biochar.svg`,
  },
  [LegacyCarbonRemovalProjectType.DirectAirCapture]: {
    icon: <></>,
    pictogram: "",
  },
  [LegacyCarbonRemovalProjectType.EnhancedRockWeathering]: {
    icon: <RemovalIcon />,
    pictogram: `${PATH}erw.svg`,
  },
  [LegacyCarbonRemovalProjectType.RegenerativeAgriculture]: {
    icon: <RemovalIcon />,
    pictogram: `${PATH}regenerative-agriculture.svg`,
  },
  [LegacyCarbonRemovalProjectType.All]: {
    icon: <></>,
    pictogram: "",
  },
  [LegacyCarbonRemovalProjectType.None]: {
    icon: <></>,
    pictogram: "",
  },
};
